<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <form (ngSubmit)="submit()">
    <mat-form-field>
      <mat-label>New password</mat-label>
      <input matInput type="password" name="password" [(ngModel)]="password" autocomplete="new-password" required>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Confirm password</mat-label>
      <input matInput type="password" name="confirm" [(ngModel)]="confirm" autocomplete="new-password" required>
    </mat-form-field>

    @if (error) {
      <p class="auth-error">{{ error }}</p>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="busy || !password || !confirm" (click)="submit()">
    Save
  </button>
</mat-dialog-actions>
